<div id="content" class="without-subnavbar allcp-form" ng-controller="WorkerController" ng-init="newWorker()">
    <div ng-include="'modules/company/menus/user_menu.html'"></div>
    <div class="panel-body">
        <form ng-submit="saveWorker()" class="form-horizontal">
            <div class="col-md-8">
                <h5 ng-if="worker.type == 'office'"> Yeni Ofis Çalışanı</h5>
                <h5 ng-if="worker.type != 'office'"> Yeni Saha Çalışanı</h5>
                <hr>
                <div class="form-group row">
                    <label class="col-md-3 control-label">Full Name: </label>
                    <div class="col-md-5">
                        <label for="name21" class="field prepend-icon">
                            <input type="text" ng-model="worker.first_name" class="event-name gui-input br-light light" placeholder="First Name" required>
                            <label for="name21" class="field-icon">
                                <i class="fa fa-user"></i>
                            </label>
                        </label>
                    </div>
                    <div class="col-md-4">
                        <label for="name21" class="field prepend-icon">
                            <input type="text" ng-model="worker.last_name" class="event-name gui-input br-light light" placeholder="Last Name" required>
                            <label for="name21" class="field-icon">
                                <i class="fa fa-user"></i>
                            </label>
                        </label>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-md-3 control-label">E-mail : </label>
                    <div class="col-md-9">
                        <label for="name21" class="field prepend-icon">
                            <input type="email" ng-model="worker.email" class="event-name gui-input br-light light" placeholder="E-mail" ng-required="worker.type == 'office'">
                            <label for="name21" class="field-icon">
                                <i class="fa fa-envelope"></i>
                            </label>
                        </label>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-md-3 control-label">Phone Number : </label>
                    <div class="col-md-9">
                        <label for="name21" class="field prepend-icon">
                            <input type="text" ng-model="worker.phone_number" class="event-name gui-input br-light light" ui-mask="(999) 999-9999"  ui-mask-placeholder ui-mask-placeholder-char=" " required>
                            <label for="name21" class="field-icon">
                                <i class="fa fa-phone"></i>
                            </label>
                        </label>
                        <p class="help-block" style="color:#999" ng-if="worker.type != 'office'">
                            * Buraya gireceğiniz numaraya mobil uygulama linki gönderilecektir.
                        </p>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-md-3 control-label">Şifre : </label>
                    <div class="col-md-9">
                        <label for="name21" class="field prepend-icon">
                            <input type="password" ng-model="worker.password" class="event-name gui-input br-light light" placeholder="******" required>
                            <label for="name21" class="field-icon">
                                <i class="fa fa-lock"></i>
                            </label>
                        </label>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-md-3 control-label">ID (Passport Or Driving Licence) : </label>
                    <div class="col-md-9">
                        <label for="name21" class="field prepend-icon">
                            <input type="text" ng-model="worker.identification_number" class="event-name gui-input br-light light" ui-mask="99999999999" ui-mask-placeholder>
                            <label for="name21" class="field-icon">
                                <i class="fa fa-user-md"></i>
                            </label>
                        </label>
                    </div>
                </div>
                <!--
                <div class="form-group row"
                    ng-if="worker.type != 'office'"
                    ng-init="worker.icon_color = colorList[0]">
                    <label class="col-md-3 control-label">İcon Renk * : </label>
                    <div class="col-md-9">
                        <ul class="color-palette" >
                            <li
                                ng-repeat="color in colorList"
                                ng-style="{'background-color': color }"
                                class="color-selected"
                                ng-click="worker.icon_color = color"
                                ng-class="worker.icon_color == color ? 'selected' : ''">
                            </li>
                        </ul>
                    </div>
                </div> -->

                <!-- <div class="form-group row">
                    <label class="col-md-3 control-label">Ekip : </label>
                    <div class="col-md-9">
                        <label for="name21" class="field">
                            <select
                                class="gui-input form-control"
                                ng-options="option.name for option in data.teams track by option.id"
                                ng-model="worker.team"
                            >
                            <option value="">Ekip Yok</option>
                            </select>
                        </label>
                    </div>
                </div> -->

                <div class="form-group row">
                    <label class="col-md-3 control-label">Dispatcher </label>
                    <div class="col-md-9">
                        <div class="checkbox-custom mt10">
                            <input type="checkbox"
                                   ng-model="worker.dispatcher"
                                   ng-checked="worker.dispatcher"
                                   id="dispatcher">
                            <label for="dispatcher">Dispatcher</label>
                        </div>
                    </div>
                </div>

                <div class="row form-group" ng-if="worker.dispatcher">
                    <label class="col-md-3 control-label">Dispatcher Stations </label>
                    <div class="col-md-9">
                        <ui-select ng-model="worker.stations" title="Select Stations" multiple>
                            <ui-select-match placeholder="Select Stations...">{{ $item.code }}</ui-select-match>
                            <ui-select-choices repeat="item as item in (stations | filter: $select.search) track by item.id">
                                <div class="row mr10 ml10">
                                    <span ng-bind="item.name"></span>
                                </div>
                            </ui-select-choices>
                        </ui-select>
                    </div>
                </div>

                <div class="row form-group">
                    <label class="col-md-3 control-label">Offer Stations </label>
                    <div class="col-md-9">
                        <ui-select ng-model="worker.offer_stations" title="Select Stations" multiple>
                            <ui-select-match placeholder="Select Stations...">{{ $item.code }}</ui-select-match>
                            <ui-select-choices repeat="item as item in (stations | filter: $select.search) track by item.id">
                                <div class="row mr10 ml10">
                                    <span ng-bind="item.name"></span>
                                </div>
                            </ui-select-choices>
                        </ui-select>
                    </div>
                </div>

                <h5 ng-if="worker.type != 'walking' && worker.type != 'office'">Vehicle Info</h5>
                <hr class="m10" ng-if="worker.type != 'walking' && worker.type != 'office'">


                <div class="form-group row" ng-if="worker.type != 'office'">
                    <label class="col-md-3 control-label">Vehicle Type : </label>
                    <div class="col-md-9">
                        <label class="radio-custom radio-primary select-worker-box radio-inline mr10"
                               ng-class="worker.type == 'Car' ? 'bg-green' : ''">
                            <input type="radio" name="type" id="type" value="Car" ng-model="worker.type">
                            <img src="/car.png" alt="" width="32px">
                        </label>
                        <label class="radio-custom radio-primary select-worker-box radio-inline mr10"
                               ng-class="worker.type == 'Suv' ? 'bg-green' : ''">
                            <input type="radio" name="type" id="type" value="Suv" ng-model="worker.type">
                            <img src="/suv.png" alt="" width="32px">
                        </label>
                        <label class="radio-custom radio-primary select-worker-box radio-inline mr10"
                               ng-class="worker.type == 'Van' ? 'bg-green' : ''">
                            <input type="radio" name="type" id="type" value="Van" ng-model="worker.type">
                            <img src="/van.png" alt="" width="32px">
                        </label>
                        <label class="radio-custom radio-primary select-worker-box radio-inline mr10"
                               ng-class="worker.type == 'Truck' ? 'bg-green' : ''">
                            <input type="radio" name="type" id="type" value="Truck" ng-model="worker.type">
                            <img src="/truck.png" alt="" width="32px">
                        </label>
                    </div>
                </div>

                <div class="form-group row" ng-if="worker.type != 'walking' && worker.type != 'office'">
                    <label class="col-md-3 control-label">Vehicle Year : </label>
                    <div class="col-md-9">
                        <label for="name21" class="field">
                            <select class="gui-input form-control" ng-model="worker.vehicle_year">
                                <option value="">Please Select</option>
                                <option value="2000">2000</option>
                                <option value="2001">2001</option>
                                <option value="2002">2002</option>
                                <option value="2003">2003</option>
                                <option value="2005">2005</option>
                                <option value="2006">2006</option>
                                <option value="2007">2007</option>
                                <option value="2008">2008</option>
                                <option value="2009">2009</option>
                                <option value="2011">2011</option>
                                <option value="2012">2012</option>
                                <option value="2013">2013</option>
                                <option value="2014">2014</option>
                                <option value="2015">2015</option>
                                <option value="2016">2016</option>
                                <option value="2017">2017</option>
                                <option value="2018">2018</option>
                                <option value="2019">2019</option>
                            </select>
                        </label>
                    </div>
                </div>
                <div class="form-group row" ng-if="worker.type != 'walking' && worker.type != 'office'">
                    <label class="col-md-3 control-label">Vehicle Make : </label>
                    <div class="col-md-9">
                        <label for="name21" class="field">
                            <input type="text" ng-model="worker.vehicle_make" placeholder="Vehicle Make" class="event-name gui-input br-light light">
                        </label>
                    </div>
                </div>
                <div class="form-group row" ng-if="worker.type != 'walking' && worker.type != 'office'">
                    <label class="col-md-3 control-label">Vehicle Model : </label>
                    <div class="col-md-9">
                        <label for="name21" class="field">
                            <input type="text" ng-model="worker.vehicle_model" placeholder="Vehicle Model" class="event-name gui-input br-light light">
                        </label>
                    </div>
                </div>
                <div class="form-group row" ng-if="worker.type != 'walking' && worker.type != 'office'">
                    <label class="col-md-3 control-label">Plate Number : </label>
                    <div class="col-md-9">
                        <label for="name21" class="field">
                            <input type="text" ng-model="worker.number_plate" placeholder="Plate Number" class="event-name gui-input br-light light">
                        </label>
                    </div>
                </div>
                <h5>Payment Info</h5>
                <hr class="m10">

                <div class="form-group row">
                    <label class="col-md-3 control-label">Account Holder Name : </label>
                    <div class="col-md-9">
                        <label for="name21" class="field prepend-icon">
                            <input type="text" ng-model="worker.account_holder_name" class="event-name gui-input br-light light" placeholder="Account Holder Name">
                            <label for="name21" class="field-icon">
                                <i class="fa fa-money"></i>
                            </label>
                        </label>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-md-3 control-label">Account Number : </label>
                    <div class="col-md-9">
                        <label for="name21" class="field prepend-icon">
                            <input type="text" ng-model="worker.account_number" class="event-name gui-input br-light light" placeholder="Account Number">
                            <label for="name21" class="field-icon">
                                <i class="fa fa-money"></i>
                            </label>
                        </label>
                    </div>
                </div>


                <div class="form-group row">
                    <label class="col-md-3 control-label"></label>
                    <div class="col-md-9">
                        <div class="btn-group pull-right">
                            <button type="submit" class="btn btn-primary" ng-click="saveAndNew = false;"><i class="fa fa-save"></i> Kaydet</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>

<!-- Account Limit -->
<!-- <div class="modal fade" id="accountLimit" tabindex="-1" role="dialog" aria-labelledby="accountLimitLabel">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="accountLimitLabel">Dikkat!</h4>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-12">
                        <p>Paketinizde bulunan kullanıcı tanımlama hakkı bitmiştir. Daha fazla kullanıcıya ihtiyacınız varsa lütfen paketinizi yükseltiniz.</p>
                    </div>
                </div>
            </div>
            <div class="modal-footer bg-light">
                <a href="calisan-yonetimi" ng-click="closeModal('#accountLimit')" class="btn btn-default">Geri Dön</a>
                <a href="hesap-bilgileri" ng-click="closeModal('#accountLimit')" class="btn btn-success">Paketimi Yükselt</a>
            </div>
        </div>
    </div>
</div>   -->
